import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import b_ from 'b_';
import './styles.scss';
import Title from '../../../Components/Title';
import Alert from '../../../Components/Alert';
import StepButton from '../../../Components/StepButton';
import ResendBlock from '../../../Components/ResendBlock';
import TransferTimeline from '../../../Components/TransferTimeline';
import cx from '../../../Utils/cx';
import inventoryUrl from '../../../Utils/inventoryUrl';
import {
  isTransferSuccess,
  resolveTransferStart,
} from '../../../Utils/transferStatus';
import { getTransferStatus } from '../../../Reducers/main/selectors';
import { getGiftData, stopGiftPolling } from '../../../Reducers/main/actions';

const b = b_.lock('GetGame');

function GetGame({ className = '', number }) {
  const {
    transferStatus,
    transferStartedAt,
    pollingStartedAt,
    giftcode,
    error,
    userId,
    quickInvite,
  } = useSelector(getTransferStatus, shallowEqual);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getGiftData());
    return () => dispatch(stopGiftPolling());
  }, [dispatch, giftcode]);

  const startedAt = resolveTransferStart(transferStartedAt, giftcode);

  return (
    <div className={cx(b(), className)}>
      <StepButton
        completeMessage={t('transfer.summary')}
        isComplete={isTransferSuccess(transferStatus)}
        dashed
        icon={<div className={b('iconStar')} />}
      >
        {number}
      </StepButton>
      <Title className={b('title')} level={2}>
        {t('transfer.title')}
      </Title>
      <TransferTimeline
        status={transferStatus}
        error={error}
        startedAt={startedAt}
        pollingStartedAt={pollingStartedAt}
        inventoryHref={inventoryUrl(userId)}
      />
      {error && !isTransferSuccess(transferStatus) && (
        <Alert className={b('error')} error={error} />
      )}
      {quickInvite && <ResendBlock className={b('resend')} />}
    </div>
  );
}

GetGame.defaultProps = {
  number: 4,
};

GetGame.propTypes = {
  className: PropTypes.string,
  // Step number shown in the circle: 3 in the Quick Invite flow, 4 after the friend-request step
  number: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
};

export default GetGame;
